class BogaCardCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.carousel = this.querySelector('.card-carousel');
    this.slides = this.carousel.querySelectorAll('.card-carousel__slide');
    this.prevBtns = this.querySelectorAll('.card-carousel__fallback-btn--prev');
    this.nextBtns = this.querySelectorAll('.card-carousel__fallback-btn--next');
    this.currentIndex = 0;

    this.carousel.addEventListener('scrollsnapchange', (e) => this.updateActiveIndex(e));

    // Button event listeners
    if (this.prevBtns.length) {
      this.prevBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.scrollToSlide(this.currentIndex - 1));
      });
    }
    if (this.nextBtns.length) {
      this.nextBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.scrollToSlide(this.currentIndex + 1));
      });
    }
  }

  scrollToSlide(index) {
    const newIndex =
      index < 0 ? this.slides.length - 1 : index > this.slides.length - 1 ? 0 : index;

    // console.log(index, newIndex);
    this.slides[newIndex].scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });

    this.currentIndex = newIndex;
  }

  updateActiveIndex(e) {
    this.currentIndex = e.snapTargetInline.dataset.label.split(' ')[1] - 1;
  }
}

window.customElements.define('boga-card-carousel', BogaCardCarousel);
